import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import UserView from './UserView';
import AdminView from './AdminView';

const T5View = () => {
  const { user } = useAuth();

  return (
    <div>
      {/* Main content - UserView for admin or regular user */}
      {user?.role === 'admin' ? (
        <AdminView engineType="T5" />
      ) : (
        <UserView engineType="T5" />
      )}
    </div>
  );
};

export default T5View;